'use strict';
var unitas = unitas || {};
const listShowMoreTriggers = document.querySelectorAll('.js-loop-list-item-list-show-more');
const lists = document.querySelectorAll('.js-loop-list-item-list');
unitas.list = unitas.list || function () {
	function init() {
        if(listShowMoreTriggers) {
            for (let i = 0; i < listShowMoreTriggers.length; i++) {
                const currentTrigger = listShowMoreTriggers[i];

                currentTrigger.addEventListener('click', function(e){
                    const clickedTrigger = e.currentTarget;
                    const theList = clickedTrigger.parentNode.querySelector('.js-loop-list-item-list');
                    const itemsInTheList = theList.querySelectorAll('.js-item-list-item');
                    const maxHeight = itemsInTheList[0].scrollHeight;

                    if(!clickedTrigger.classList.contains('hide')) {
                        clickedTrigger.classList.add('hide');
                    } 
                    
                    if(itemsInTheList) {
                        for (let i = 0; i < itemsInTheList.length; i++) {
                            const currentItem = itemsInTheList[i];
                            currentItem.style.display = 'grid';

                            setTimeout(() => {
                                // currentItem.style.maxHeight = maxHeight + 'px';
                            }, 0);
                        }
                    }
                });
            }
        }
	}
	return {
		init : init
	};
}();